document.querySelectorAll('.accordion details').forEach((details) => {
  const summary = details.querySelector(':scope > summary');
  const content = summary ? summary.nextElementSibling : null;
  if (!summary || !content) return;

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    if (details.dataset.animating === 'true') return;
    details.dataset.animating = 'true';

    if (details.open) {
      content.style.transitionTimingFunction = 'ease-in';
      content.style.height = content.scrollHeight + 'px';
      // Force a reflow so the browser registers the start height before we change it.
      content.offsetHeight;
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      const handler = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        details.open = false;
        content.style.height = '';
        details.dataset.animating = 'false';
      };
      content.addEventListener('transitionend', handler);
    } else {
      details.open = true;
      content.style.transitionTimingFunction = 'ease-out';
      const endHeight = content.scrollHeight;
      content.style.height = '0px';
      content.offsetHeight;
      requestAnimationFrame(() => {
        content.style.height = endHeight + 'px';
      });

      const handler = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        content.style.height = '';
        details.dataset.animating = 'false';
      };
      content.addEventListener('transitionend', handler);
    }
  });
});
